export default __webpack_public_path__ + "static/media/store.38bdf9c6.png";